import { LoadingSpinnerContainer } from 'component/progress/loading-spinner';
import { useProfile } from 'data/profile';
import { Stack, useLocalSearchParams } from 'expo-router';
import { moderationDashModuleQuery, useModule } from 'system/structure-modules';

export default function ModerationDashboardUserPostsScreen() {
    const { ModerationDashUserPage } = useModule(moderationDashModuleQuery);
    const { userKey } = useLocalSearchParams<'/[siloKey]/moderationdash/one/posts/[userKey]'>();
    const { profile } = useProfile(userKey);
    if (!profile) return <LoadingSpinnerContainer />;
    return (
        <>
            <Stack.Screen options={{ title: profile.name }} />
            <ModerationDashUserPage userKey={userKey} />
        </>
    );
}
